import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { articuloPorSlug } from "@/lib/articulos";
import { contenidoArticulosInicial } from "@/lib/use-articulos";
import { Route as rootRoute } from "./__root";

// Plantilla única para todos los artículos (ver src/components/ArticuloPlantilla.tsx). El `head` usa la copia del contenido tomada al
// compilar; la página usa el contenido vivo. Sin artículo publicado muestra «no encontrado» con noindex.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/articulos/$slug",
  head: ({ params }) => {
    const a = articuloPorSlug(contenidoArticulosInicial(), params.slug);
    if (!a) return {};
    const path = `/articulos/${a.slug}`;
    return {
      meta: seoMeta({ title: `${a.titulo} — Calistenia Progresiva`, description: a.descripcion, path }),
      links: [canonicalLink(path)],
    };
  },
  component: lazyRouteComponent(() => import("./articulo-page"), "ArticuloPage"),
});
